const propertyTypes = ['property', 'houses', 'flats', 'farms_land'] as const;

const propertySubTypes = [
    'detached',
    'semi_detached',
    'terraced',
    'flats',
    'bungalow',
    'farms_land',
    'park_home'
] as const;

export type PropertyType = (typeof propertyTypes)[number];
export type PropertySubTypes = Array<(typeof propertySubTypes)[number]>;

export function getPropertyType(
    propertySubTypes: PropertySubTypes
): PropertyType {
    const isHouses = () => {
        if (propertySubTypes.length === 0) {
            return false;
        }

        const remainingProperty = propertySubTypes.filter((propertySubType) => {
            return (
                [
                    'detached',
                    'semi_detached',
                    'terraced',
                    'park_home',
                    'bungalow'
                ].includes(propertySubType) === false
            );
        });

        return remainingProperty.length === 0;
    };

    const isFlats = () => {
        return (
            propertySubTypes.length === 1 && propertySubTypes.includes('flats')
        );
    };

    const isFarmsLand = () => {
        return (
            propertySubTypes.length === 1 &&
            propertySubTypes.includes('farms_land')
        );
    };

    if (isHouses()) {
        return 'houses';
    } else if (isFlats()) {
        return 'flats';
    } else if (isFarmsLand()) {
        return 'farms_land';
    }

    return 'property';
}
